module.exports = __webpack_public_path__ + "img/Insta-Bsp-04.65a38c84.jpg";